import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;

export const fetchcities = createAsyncThunk(
  "Cities/fetchcities",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/cities`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;
      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);
export const fetchcityById = createAsyncThunk(
  "Cities/fetchcityById",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/city/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;
      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);

export const addCity = createAsyncThunk(
  "Cities/addCity",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.post(`${BaseUrl}/city`,data, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: 'تم الإضافة بنجاح',
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);

export const updateCity = createAsyncThunk(
  "Cities/updateCity",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.post(`${BaseUrl}/city/${data.id}`,data, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: 'تم التعديل بنجاح',
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCity = createAsyncThunk(
  "Cities/deleteCity",
  async ( id , thunkAPI) => {
  
    
    const { rejectWithValue } = thunkAPI;
    try {
      
      const response = await axios.post(`${BaseUrl}/cityDelete/${id}`, {},{
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      if (
        response.data.code === 200 
 
      ) {
        sweetalert({
          text: "تم الحذف بنجاح",
          icon: "success",
          buttons: {
            confirm: {
              text: "تم",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        }).then(() => {
          window.location.reload();
        });
      } else {
        // Handle other responses if needed
        // For example, you can display an error message for failed deletion
        // You can access the specific error message from the response's "data" object
        sweetalert({
          text: response.data.data.original.message,
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        // Handle the 403 Forbidden error specifically
        sweetalert({
          text: "ليس لديك صلاحية للقيام بهذا",
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      } else if (error.response && error.response.status === 500) {
        sweetalert({
          text: error.response.data.message ||error.response.data.data ,
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      } 
      else if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        sweetalert({
          text: error.response.data.data[0],
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
       else {
        // Handle other errors with a generic message
        const errorMessage =
          error.response?.data?.message || error.response?.data?.data;
        sweetalert({
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
      return rejectWithValue(error.message);
    }
  }
);
const CitySlice = createSlice({
  name: "Cities",
  initialState: {
    Cities:'',
    Cityid: '',
    Cityupdate: [],
    CityAdd: [],
    loading: false,
    loadingUpdate: false,
    error: null,
  },
  reducers: {
    clearCity: (state) => {

      state.Cities = '';
      state.Cityid = '';
      state.Cityupdate = [];
      state.CityAdd = [];
      state.loading = false;
      state.loadingUpdate = false;
      state.error = null;
    },
  },
  extraReducers: {

    // fetch All city by id 
    [fetchcities.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchcities.fulfilled]: (state, action) => {
      state.Cities = action.payload;
      state.loading = false;
    },
    [fetchcities.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    // fetch All city by id 
    [fetchcityById.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchcityById.fulfilled]: (state, action) => {
      state.Cityid = action.payload;
      state.loading = false;
    },
    [fetchcityById.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    // addCity city by id 
    [addCity.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [addCity.fulfilled]: (state, action) => {
      state.CityAdd = action.payload;
      state.loading = false;
    },
    [addCity.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    // update Profit by id 
    [updateCity.pending]: (state, action) => {
      state.loadingUpdate = true;
      state.error = null;
    },
    [updateCity.fulfilled]: (state, action) => {
      state.Cityupdate = action.payload;
      state.loadingUpdate = false;
    },
    [updateCity.rejected]: (state, action) => {
      state.error = action.payload;
      state.loadingUpdate = false;
    },
 //delete  city
    [deleteCity.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [deleteCity.fulfilled]: (state, action) => {
      if (action.payload && action.payload.id) {
        state.Cities = state.Cities.filter((el) => el.id !== action.payload.id);
      }
      state.loading = false;
    },
    [deleteCity.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },


  },
});
export const { clearCity } = CitySlice.actions;
export default CitySlice.reducer;
